module.exports = __webpack_public_path__ + "static/media/banner-manual-do-transportador-celular-maxi-frete.14f4d831.png";